import cx from 'classnames';
import SVG from 'react-inlinesvg';
import { IHeaderGroupParams } from 'ag-grid-community';
import arrowLightLeft from 'assets/icons/arrow_light_left.svg';
import arrowLightRight from 'assets/icons/arrow_light_right.svg';
import { HeaderBackgroundColor } from 'components/common/TableHeader/TableHeader.types';
import usePendoTracking from 'customHooks/usePendoTracking';

export interface HeaderProps extends IHeaderGroupParams {
  backgroundColor?: HeaderBackgroundColor;
  collapsedBackgroundColor?: HeaderBackgroundColor;
  expandedBackgroundColor?: HeaderBackgroundColor;
  isPinnedDuplicateHidden?: boolean;
  label: string;
  headerLevel?: string;
}

export const HeaderGroupComponent: React.FC<HeaderProps> = ({
  backgroundColor,
  collapsedBackgroundColor = HeaderBackgroundColor.PRIMARY,
  expandedBackgroundColor = HeaderBackgroundColor.SECONDARY,
  isPinnedDuplicateHidden,
  label,
  headerLevel,
  ...headerGroupParams
}) => {
  const { getPendoDataId } = usePendoTracking();

  const isExpanded = headerGroupParams.columnGroup.getProvidedColumnGroup().isExpanded();

  const handleExpandOrCollapse = (): void => {
    headerGroupParams.setExpanded(!isExpanded);
  };

  if (isPinnedDuplicateHidden && headerGroupParams.columnGroup.getPartId() === 1) {
    return null;
  }

  return (
    <button
      className={cx('flex items-center px-2 py-1.5 text-neutral-950 rounded-sm w-full m-0.5', {
        'justify-between': isExpanded,
        [`${backgroundColor}`]: !!backgroundColor,
        [`${expandedBackgroundColor}`]: isExpanded && !backgroundColor,
        [`${collapsedBackgroundColor}`]: !isExpanded && !backgroundColor,
      })}
      onClick={handleExpandOrCollapse}
      type="button"
      data-dd-action-name={`Allocation report / Expand or collapse ${headerLevel}`}
      data-pendo-id={getPendoDataId(`Allocation expand or collapse ${headerLevel}`)}
    >
      <span className="sub-header-sm">{label}</span>
      <SVG
        src={isExpanded ? arrowLightLeft : arrowLightRight}
        className={cx('h-4 w-4 ml-auto', {
          'ml-2': isExpanded,
        })}
      />
    </button>
  );
};
